import { render, staticRenderFns } from "./ErrorSignaturePage.vue?vue&type=template&id=48c4cea8&"
import script from "./ErrorSignaturePage.vue?vue&type=script&lang=js&"
export * from "./ErrorSignaturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports